define((require) => {
    "use strict";

    var Permissions      = require("shared/security/Permissions"),
        SettingsView     = require("ui/settings/SettingsView"),
        {isBlank}        = require("shared/util/StringUtils"),
        template         = require("ui/settings/analytics/AnalyticsView.tpl"),
        ValidateBehavior = require("ui/behaviors/ValidateBehavior");

    return SettingsView.extend({

        className: SettingsView.prototype.className + " analytics-view",

        template: template,

        templateHelpers: function() {
            return {
                permissionToManage: Permissions.Privileges.ADMIN.can()
            };
        },

        ui: {
            tabMenuItem:       ".tab",
            googleAnalytics:   ".google-analytics",
            segmentIo:         ".segment-io",
            googleAnalyticsId: ".ga-key",
            segmentIoApiKey:   ".segment-key"
        },

        bindings: {
            ".ga-key": "googleAnalyticsId",
            ".segment-key": "segmentIoApiKey",
            ".notification-box": {
                observe: ["googleAnalyticsId", "segmentIoApiKey"],
                updateView: false,
                visible: function(values) {
                    return values[0] && values[0].length >= 0 && values[1] && values[1].length >= 0;
                }
            }
        },

        behaviors: {
            validateBehavior: {
                behaviorClass: ValidateBehavior,
                inputValidation: {
                    ".ga-key": {
                        validateAfter: "beforeSubmit",
                        model:     true,    // mark as bound to model, so make sure we cancel pending save requests on error!
                        validator: function(key) {
                            return isBlank(key) || /^UA-\d{4,}-\d+$/.test(key); // GA tracking ids can have slightly different formats, found this online somewhere... :)
                        },
                        errorText: function() {
                            return "Not a valid Google Analytics Tracking ID";
                        }
                    },
                    ".segment-key": {
                        validateAfter: "beforeSubmit",
                        model:     true,    // mark as bound to model, so make sure we cancel pending save requests on error!
                        validator: function(key) {
                            return isBlank(key) || /^\w{10,}$/.test(key); // at least 10 word characters (upper/lowercase letters + digits)
                        },
                        errorText: function() {
                            return "Not a valid Segment.io Write Key";
                        }
                    }
                }
            }
        },

        events: {
            "click @ui.tabMenuItem": "_tabSelectionHandler"
        },

        onRender: function() {
            this._defaultAnalyticsSelection();
        },

        /**
         * @private
         * Handles tab clicks and calls to select the tab.
         * @param  {Event} event The click event.
         */
        _tabSelectionHandler: function(event) {
            var tabName;

            if (event.target.classList.contains("segment-io")) {
                tabName = "segmentIo";
            } else if (event.target.classList.contains("google-analytics")) {
                tabName = "googleAnalytics";
            }

            this._selectTab(tabName);
        },

        /**
         * @private
         * Checks if/which analytics the company uses, and activates the tab accordingly.
         */
        _defaultAnalyticsSelection: function() {
            var hasGoogleId = this.model.get("googleAnalyticsId"),
                hasSegmentIoKey = this.model.get("segmentIoApiKey");

            if (hasSegmentIoKey && !hasGoogleId) {
                this._selectTab("segmentIo");
            } else {
                this._selectTab("googleAnalytics");
            }
        },

        /**
         * @private
         * Toggles active class on tabs and content.
         *
         * @param {String} tabName The tabName that should be activated.
         */
        _selectTab: function(tabName) {
            this.ui.segmentIo.toggleClass("active", tabName === "segmentIo");
            this.ui.googleAnalytics.toggleClass("active", tabName === "googleAnalytics");
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/analytics/AnalyticsView.js